
import Vue from "vue";
import Component from "vue-class-component";

@Component({
  data() {
    return {
      pdfUrl: "",
    };
  },
})
export default class PDFReport extends Vue {
  name = "PDFReport";
  loading = true;
  pdfUrl = "";
  created() {
    this.pdfUrl = this.$route.query.pdfUrl
      ? this.$route.query.pdfUrl.toString()
      : "";
  }
  onIframeLoad() {
    this.loading = false;
  }
}
